<template>
    <div class="pa-2 ">
        <v-row>
            <v-col cols="12" md="4">
                <label class="field_label">Course</label>
                <v-select v-model="filters.id_course" :items="coursesOptions" item-title="text" item-value="value"
                    density="compact" hide-details @update:model-value="onFilterChange"></v-select>
            </v-col>
            <v-col cols="12" md="4">
                <label class="field_label">Nombre de récompenses scratch</label>
                <v-text-field v-model.number="filters.nb_recompenses_scratch" type="number" min="1" max="100"
                    density="compact" hide-details @update:model-value="onFilterChange"></v-text-field>
            </v-col>
            <v-col cols="12" md="4">
                <label class="field_label">Nombre de récompenses par catégorie</label>
                <v-text-field v-model.number="filters.nb_recompenses_categorie" type="number" min="1" max="100"
                    density="compact" hide-details @update:model-value="onFilterChange"></v-text-field>
            </v-col>
        </v-row>
    </div>
</template>

<script>
import { mapStores } from "pinia";
import { useMainStore } from "@/stores/mainStore";
import AdminService from "@/services/admin.service";

export default {
    computed: {
        ...mapStores(useMainStore),
        coursesOptions() {
            let options = [];
            if (this.courses && this.courses.length > 0) {
                options = this.courses.map((course) => {
                    return {
                        text: course.nom,
                        value: course.id,
                    };
                });
            }
            return options;
        },
    },
    data() {
        return {
            courses: [],
            filters: {
                id_course: null,
                nb_recompenses_scratch: 3,
                nb_recompenses_categorie: 3,
            },
        };
    },
    methods: {
        async loadCourses() {
            if (!this.mainStore.module?.id) return;
            let res = await AdminService.getCourses(this.mainStore.module.id);
            if (res) {
                this.courses = res;
                this.filters.id_course = this.courses[0].id;
                this.onFilterChange();
            }
        },
        onFilterChange() {
            this.$emit("filter-change", { ...this.filters });
        },
    },
    async mounted() {
        await this.loadCourses();
    },
};
</script>

<style lang="scss" scoped></style>